import { DealFiltersSortBy } from './types'

export const sortByLabels: { [k in DealFiltersSortBy]: string } = {
  featured: 'Featured',
  'price-low-high': 'Price: low to high',
  'price-high-low': 'Price: high to low',
} as const
